import {FC, PropsWithChildren} from 'react'

import {MainHeader} from '@/components/header/MainHeader'
import {Page} from '@/components/Page'
import {HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE} from '@/theme/sizing'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Container} from './Container'

type LayoutProps = {
  hasLogin?: boolean
}

export const Layout: FC<PropsWithChildren<LayoutProps>> = ({hasLogin = true, children}) => {
  return (
    <>
      <Page
        header={<MainHeader hasRegionalSettings hasGetHelpButton={false} hasLogin={hasLogin} />}
        hasFooter={false}
      >
        <div className="layout">
          <Container>{children}</Container>
        </div>
      </Page>

      <style jsx>{`
        .layout {
          display: flex;
          min-height: calc(100vh - ${HEADER_HEIGHT_DESKTOP});
          min-height: calc(100svh - ${HEADER_HEIGHT_DESKTOP});
        }
        @media ${TABLET_SCREENSIZE} {
          .layout {
            min-height: calc(100vh - ${HEADER_HEIGHT_MOBILE});
            min-height: calc(100svh - ${HEADER_HEIGHT_MOBILE});
          }
        }
      `}</style>
    </>
  )
}
